export default [
  {
    title: 'Auto Payment',
    key: 'autorenewals',
    url: '/autorenewals',
    icon: 'icmn icmn-credit-card',
  },
  {
    title: 'Rental Order',
    key: 'rentalorders',
    url: '/rental/orders',
    icon: 'icmn icmn-cart',
    children: [
      {
        title: 'Rental List',
        key: 'rentalorderlist',
        url: '/rental/orders',
      },
      {
        title: 'List Over Due',
        key: 'overdueorders',
        url: '/rental/overdueorders',
      },
    ],
  },
  {
    title: 'Device Buy Order',
    key: 'devicebuyorder',
    url: '/devicebuyorders',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'Recharge Device Order',
    key: 'device-recharge-orders',
    url: '/device-recharge-orders',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'Sim Card Buy Order',
    key: 'simbuyorders',
    url: '/simbuyorders',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'Recharge SIM Orders',
    key: 'rechargesimorders',
    url: '/recharge/orders',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'API Recharge Order',
    key: 'api-recharge-orders',
    url: '/api-recharge-orders',
    icon: 'icmn icmn-cart',
  },
  {
    title: 'Activation',
    key: 'activation',
    icon: 'fas fa-boxes',
    children: [
      {
        title: 'Activate Device Requests',
        key: 'activateDeviceRequests',
        url: '/activate/devicerequests'
      },
      {
        title: 'Activate Sim Requests',
        key: 'activateSimRequests',
        url: '/activate/simrequests'
      },
      {
        title: 'Amazon Orders',
        key: 'amazonOrders',
        url: '/activate/amazonorders'
      },
    ],
  },
  {
    title: 'Inventory',
    key: 'inventory',
    url: '/devices/inventory',
    icon: 'fas fa-boxes',
    children: [
      {
        title: 'Devices',
        key: 'devicesInventory',
        url: '/devices/inventory',
      },
      {
        title: 'Active Lines',
        key: 'activeLinesInventory',
        url: '/activelines/inventory',
      },
      {
        title: 'Sim Cards',
        key: 'simInventory',
        url: '/sim/inventory',
      },
    ],
  },
  {
    title: 'Management',
    key: 'management',
    url: '/expiration/devices',
    icon: 'fas fa-tasks',
    children: [
      {
        title: 'Expiration',
        key: 'devicesInventory',
        url: '/devices/inventory',
        children: [
          {
            title: 'Devices',
            key: 'expirationDevices',
            url: '/expiration/devices',
          },
          {
            title: 'Sim Cards',
            key: 'expirationSim',
            url: '/expiration/sim',
          },
        ],
      },
      {
        title: 'Devices',
        key: 'managementDevices',
        url: '/management/devices',
      },
      {
        title: 'Lines',
        key: 'managementLines',
        url: '/management/lines',
      },
    ],
  },
  {
    title: 'Customer',
    key: 'customer',
    url: '/customers',
    icon: 'fas fa-users',
  },
  {
    title: 'Promotion',
    key: 'promotion',
    icon: 'fas fa-comment-dollar',
    url: '/discounts',
  },
  {
    title: 'Catalog',
    key: 'catalog',
    // icon: 'fas fa-warehouse',
    icon: 'fa fa-tags fw',
    children: [
      {
        title: 'Categories',
        key: 'categories',
        url: '/categories',
      },
      {
        title: 'Products',
        key: 'products',
        url: '/list/products',
      },
      {
        title: 'Options',
        key: 'product_options',
        url: '/options',
      },
      {
        title: 'Recurring Profile',
        key: 'recurring_profile',
        url: '/recurring/profiles',
      },
    ],
  },
  {
    title: 'Manage Admins',
    key: 'admins',
    url: '/admins',
    icon: 'fas fa-lock',
  },
]



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/menuData.js